import { CompletePageConditionalRuleModel } from '@/domain/model/forms'
import { FormAddConditionCompletePageModel } from '@/pages/FormBuilderSettingsCompletePage/Components/ConditionCompletePage/useAddConditionCompletePageForm'

export const transformFromResponseToCompleteConditionalRuleForm = (
  response?: CompletePageConditionalRuleModel[]
): FormAddConditionCompletePageModel[] | undefined => {
  return response?.map((item) => {
    let url = null
    let complete_page = null
    const hasCompletePage = Boolean(item.custom_complete_page)
    const hasUrl = Boolean(item.redirect_url)
    if (hasCompletePage) {
      complete_page = item.custom_complete_page
    }
    if (hasUrl) {
      url = item.redirect_url
    }
    return {
      conditional_rule_groups: item.conditional_rule_groups.map(
        (group, groupIndex) => ({
          conditional_rules: group.conditional_rules.map((rule, ruleIndex) => {
            const expected_answer = rule.expected_answer
            return {
              type: groupIndex && !ruleIndex ? 'OR' : 'AND',
              question: String(rule.question),
              operator: rule.operator,
              expected_answer,
            }
          }),
        })
      ),
      order: item.order,
      is_new: item.is_new ?? false,
      is_updated: item.is_updated ?? false,
      enabled: item.enabled ?? true,
      id: item.id,
      form: item.form,
      packet: item.packet,
      if_met: hasUrl ? 'redirect_url' : 'custom_page',
      url,
      complete_page,
    }
  })
}
